import React, { useState, useEffect } from "react";
import classNames from "classnames";

export default function Input(props) {
  const { id, label, className = "", placeholder, type = "text", ...logicProps } = props;
  const {
    register,
    unregister,
    setValue,
    setFormValues,
    formValues,
    required,
    validate,
    errorMessage,
    defaultValue,
    value,
    pattern,
    ...inputProps
  } = logicProps;
  const [internalValue, setInternalValue] = useState(value || defaultValue);
  const [isValid, setIsValid] = useState(!required);
  const [isVisited, setIsVisited] = useState(false);
  const shouldShowError = !isValid && isVisited;

  useEffect(() => {
    register(id, value || internalValue);
    return () => unregister(id);
  }, [register, unregister, id, value, internalValue]);

  const validateFunction = validate || (required && Boolean);
  const onChange = (event) => {
    const newValue = event.target.value;
    setInternalValue(newValue);
    setValue(id, newValue);
    if (validateFunction) setIsValid(validateFunction(newValue));
  };
  const withRequired = (string) => string + (required ? " *" : "");
  return (
    <div className={classNames("mb-4", className)}>
      {label && <label className="block my-2 font-semibold">{withRequired(label)}</label>}
      <input
        className="w-full px-2 py-3 bg-gray-100 border border-gray-400"
        id={id}
        onChange={onChange}
        onBlur={(e) => {
          setIsVisited(true);
          if (validateFunction) setIsValid(validateFunction(value ? value : internalValue));
          if (typeof props.onBlur === "function") props.onBlur(e);
        }}
        value={value ? value : internalValue}
        required={required}
        placeholder={placeholder}
        type={type}
        pattern={pattern}
        {...inputProps}
      />
      {shouldShowError && <p className="text-red-400">{errorMessage}</p>}
    </div>
  );
}
